<template>
  <section class="app-section">
    <header class="app-header flex justify-between items-center">
      <h2 class="app-h2">画像の新規アップロード</h2>
    </header>
    <div class="padding">
      <el-upload class="image-uploader" drag
        ref="upload"
        :action="mediaUploadUrl"
        :on-preview="onPreview"
        :on-remove="onRemove"
        :file-list="media"
        list-type="picture"
        :multiple="true"
        :http-request="onHttpRequest">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">ファイルをドラッグするか<em>クリックしてアップロードしてください</em>。<span style="color:red">ファイル名は英数字にしてください。</span></div>
      </el-upload>
    </div>
  </section>
</template>

<script>
export default {
  name: 'media-upload',
  data: function () {
    return {
      media: []
    }
  },
  computed: {
    mediaUploadUrl: function () {
      return this.$store.getters['wordpress/account/url'] + this.$store.getters['wordpress/media/uploadPath']
    }
  },
  methods: {
    /**
     * el-uploadコンポーネントのHTTP Request処理を指定
     */
    onHttpRequest: function (option) {
      this.$store.dispatch('wordpress/media/create', option)
    },
    onSubmit: function (ev) {
      this.$refs.upload.submit()
    },
    onPreview: function (ev) {
      // console.log(ev)
    },
    onRemove: function (ev) {
      // console.log(ev)
    }
  }
}
</script>

<style lang="scss">
.image-uploader {
  width: 100%;
  & .el-upload,
  & .el-upload-dragger {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routes/MediaUpload.vue